export const MAX_PREVIEW_IMAGE_DATA_URI_LENGTH = 512 * 1024;

const SAFE_PREVIEW_IMAGE_PATTERN = /^data:image\/(?:jpeg|png);base64,[A-Za-z0-9+/]+={0,2}$/;

export function isSafeDashboardPreviewImage(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.length <= MAX_PREVIEW_IMAGE_DATA_URI_LENGTH &&
    SAFE_PREVIEW_IMAGE_PATTERN.test(value)
  );
}
